/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroups,
    GetOutletByGroupID,
    GetCustomerOrdersOutletWiseDetails,
    GetAllConfigarationValues,
    GetApprovedProductPrice,
    GeneratePerformOrderOutletWise,
    CheckOutletWiseCustomerOrders,
    UpdatePerformOrder,
    GetAllProductsDetails
};

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetOutletByGroupID(groupID) {
    const response = await CommonGet('/api/CustomerOrdersOutletWise/GetOutletByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetCustomerOrdersOutletWiseDetails(factoryID, date) {
    const response = await CommonGet('/api/CustomerOrdersOutletWise/GetCustomerOrdersOutletWiseDetails', 'operationEntityID=' + parseInt(factoryID) + '&date=' + date);
    return response.data;
}

async function GetAllConfigarationValues(groupID, operationEntityID) {
    const response = await CommonGet('/api/Configuration/GetAllConfigarationValues', 'groupID=' + parseInt(groupID) + '&operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}

async function GetApprovedProductPrice(date) {
    const response = await CommonGet('/api/ProductPrice/GetApprovedProductPriceByDate', 'date=' + date);
    return response.data;
}

async function GeneratePerformOrderOutletWise(createdBy, date) {
    const response = await CommonGet('/api/CustomerOrdersOutletWise/GeneratePerformOrderOutletWise', 'createdBy=' + parseInt(createdBy) + '&date=' + date);
    return response;
}

async function CheckOutletWiseCustomerOrders(date) {
    const response = await CommonGet('/api/CustomerOrdersOutletWise/CheckOutletWiseCustomerOrders', 'date=' + date);
    return response.data;
}

async function UpdatePerformOrder(data) {
    const response = await CommonPost('/api/OutletOrder/UpdatePerformOrder', null, data);
    return response;
}

async function GetAllProductsDetails() {
    const response = await CommonGet('/api/Product/GetAllProductsDetails', null);
    return response.data;
}